"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.capDuration = exports.handleError = exports.blockDetailsForBlockElement = exports.blockDetailsForChildElement = exports.blockIdForChildElement = exports.blockIdForBlock = exports.calculatePercentageOfView = exports.getVisibleBlocks = exports.createEventSender = exports.isTimingCaptureEnabled = exports.getAnalyticsIngestionUrl = exports.getAnalyticsConfig = exports.getPageTrackingInfo = exports.millisOnPage = void 0;
var timeme_js_1 = __importDefault(require("timeme.js"));
var axios_1 = __importDefault(require("axios"));
var http_1 = __importDefault(require("http"));
var https_1 = __importDefault(require("https"));
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var singleLineString_1 = __importDefault(require("@CommonFrontendBackend/Utils/singleLineString"));
var StyleServiceV2_1 = require("@CommonFrontendBackend/StyleServiceV2/StyleServiceV2");
var jquery_1 = __importDefault(require("jquery"));
var ConsoleLogEventSender_1 = require("./ContentInteractions/ConsoleLogEventSender");
var millisOnPage = function () {
    return timeme_js_1.default.getTimeOnCurrentPageInMilliseconds();
};
exports.millisOnPage = millisOnPage;
var getPageTrackingInfo = function (window) {
    if (!window.qSessionTracking) {
        return undefined;
    }
    return {
        identity: window.qSessionTracking.visit.identity,
        fullName: window.qSessionTracking.visit.fullName,
        viewUserId: window.qSessionTracking.visit.viewUserId,
        viewIdentityUnverified: window.qSessionTracking.visit.viewIdentityUnverified,
        visitToken: window.qSessionTracking.visit.token,
        pageViewId: window.qSessionTracking.visit.id,
        pageId: window.qSessionTracking.projectId,
        pageName: window.qSessionTracking.projectName,
        accountId: window.qSessionTracking.projectAccountId,
        userId: window.qSessionTracking.projectUserId,
        linkId: window.qSessionTracking.linkId,
    };
};
exports.getPageTrackingInfo = getPageTrackingInfo;
var getAnalyticsConfig = function (window) {
    var _a, _b, _c, _d;
    return {
        ingestionApiUrl: (_b = (_a = window.qAnalyticsConfig) === null || _a === void 0 ? void 0 : _a.ingestionApiUrl) !== null && _b !== void 0 ? _b : "",
        isEnabled: (_d = (_c = window.qAnalyticsConfig) === null || _c === void 0 ? void 0 : _c.enableTimingsCapture) !== null && _d !== void 0 ? _d : false,
    };
};
exports.getAnalyticsConfig = getAnalyticsConfig;
var getAnalyticsIngestionUrl = function (window) {
    return (0, exports.getAnalyticsConfig)(window).ingestionApiUrl;
};
exports.getAnalyticsIngestionUrl = getAnalyticsIngestionUrl;
var isTimingCaptureEnabled = function (window) {
    return (0, exports.getAnalyticsConfig)(window).isEnabled;
};
exports.isTimingCaptureEnabled = isTimingCaptureEnabled;
var AnalyticsEventSenderImpl = (function () {
    function AnalyticsEventSenderImpl(axiosClient, ingestionUrl) {
        this.axiosClient = axiosClient;
        this.ingestionUrl = ingestionUrl;
    }
    AnalyticsEventSenderImpl.prototype.send = function (pageEvents) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.axiosClient.post(this.ingestionUrl, pageEvents)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    return AnalyticsEventSenderImpl;
}());
var createEventSender = function (_a) {
    var axiosClient = _a.axiosClient, localAnalytics = _a.localAnalytics;
    if (localAnalytics)
        return new ConsoleLogEventSender_1.ConsoleLogAnalyticsEventSenderImpl();
    var axiosLocal = axiosClient;
    if (!axiosClient) {
        axiosLocal = createDefaultHttpClient();
    }
    var ingestionUrl = (0, exports.getAnalyticsIngestionUrl)(window);
    return new AnalyticsEventSenderImpl(axiosLocal, ingestionUrl);
};
exports.createEventSender = createEventSender;
var createDefaultHttpClient = function () {
    return axios_1.default.create({
        httpAgent: new http_1.default.Agent({ keepAlive: true }),
        httpsAgent: new https_1.default.Agent({ keepAlive: true }),
    });
};
var getVisibleBlocks = function () {
    var blocks = (0, jquery_1.default)(".project-block");
    var viewportHeight = (0, jquery_1.default)(window).height();
    return jquery_1.default.grep(blocks, function (block) {
        var rect = block.getBoundingClientRect();
        onGettingOfVisibleBlocks(block, rect, viewportHeight);
        return rect.bottom > 0 && rect.top < viewportHeight;
    });
};
exports.getVisibleBlocks = getVisibleBlocks;
var onGettingOfVisibleBlocks = function (block, rect, viewportHeight) {
    if (rect.bottom > 0 && rect.top < viewportHeight - viewportHeight * 0.05) {
        var $block = (0, jquery_1.default)(block);
        var animationOption = $block.attr("data-animation");
        if (animationOption !== commonTypes_1.AnimationOption.None) {
            if (!$block.hasClass("project-block--viewed")) {
                var animationSpeed_1 = $block.attr("data-animation-speed");
                if (animationOption === commonTypes_1.AnimationOption.Section) {
                    $block
                        .find((0, singleLineString_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                  .project-block__block-element:not(.project-block__block-element .project-block__block-element):not(.project-block__widget-element .project-block__block-element),\n                  .project-block__widget-element\n                "], ["\n                  .project-block__block-element:not(.project-block__block-element .project-block__block-element):not(.project-block__widget-element .project-block__block-element),\n                  .project-block__widget-element\n                "]))))
                        .each(function (i, element) {
                        (0, jquery_1.default)(element)[0].style.animationDelay = "".concat((0, StyleServiceV2_1.getAnimationDelayValue)(animationSpeed_1, i), "s");
                    });
                }
                $block.addClass("project-block--viewed");
            }
        }
    }
};
var calculatePercentageOfView = function (block) {
    var rect = block.getBoundingClientRect();
    var viewportHeight = (0, jquery_1.default)(window).height();
    var visibleTop = Math.max(rect.top, 0);
    var visibleBottom = Math.min(rect.bottom, viewportHeight);
    var visibleHeight = visibleBottom - visibleTop;
    return visibleHeight / viewportHeight;
};
exports.calculatePercentageOfView = calculatePercentageOfView;
var blockIdForBlock = function (blockElement) { return blockElement.attr("block-id"); };
exports.blockIdForBlock = blockIdForBlock;
var blockIdForChildElement = function (blockChildElement) {
    return blockChildElement.parents(".project-block").attr("block-id");
};
exports.blockIdForChildElement = blockIdForChildElement;
var blockDetailsForChildElement = function (element) {
    var sectionBlock = element.parents(".project-block");
    var blockId = sectionBlock.attr("block-id");
    var blockType = sectionBlock.attr("data-type");
    var blockName = sectionBlock.attr("block-name");
    return { blockId: blockId, blockType: blockType, blockName: blockName };
};
exports.blockDetailsForChildElement = blockDetailsForChildElement;
var blockDetailsForBlockElement = function (element) {
    var blockId = element.attr("block-id");
    var blockType = element.attr("data-type");
    var blockName = element.attr("block-name");
    return { blockId: blockId, blockType: blockType, blockName: blockName };
};
exports.blockDetailsForBlockElement = blockDetailsForBlockElement;
var PageTimingError = (function (_super) {
    __extends(PageTimingError, _super);
    function PageTimingError(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, PageTimingError.prototype);
        return _this;
    }
    return PageTimingError;
}(Error));
var handleError = function (err) {
    var ptError = new PageTimingError(err.message);
    console.error("Error in page timing", ptError);
};
exports.handleError = handleError;
var capDuration = function (durationMillis) { return (durationMillis > 45000 ? 5000 : durationMillis); };
exports.capDuration = capDuration;
var templateObject_1;
